import * as e from "react";
const v = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "PT_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#PT_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 0h24v24H8V0z",
      fill: "#EF0000"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0h12v24H0V0z",
      fill: "#2F8D00"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "PT_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 4,
      y: 4,
      width: 16,
      height: 16
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.906 19.807c-4.26 0-7.715-3.496-7.715-7.807 0-4.312 3.454-7.808 7.715-7.808 4.26 0 7.714 3.496 7.714 7.808 0 4.311-3.454 7.807-7.714 7.807z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#PT_svg__b)", fill: "#FFE017" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.43 4h1v2.699h-1V4zM11.43 17.493h1V20h-1v-2.506z"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M4.315 12.403l-.28-.717C7.12 10.454 9.45 9.66 11.03 9.302c2.318-.525 4.865-.914 7.641-1.166l.068.768c-2.744.25-5.258.633-7.543 1.15-1.533.348-3.829 1.13-6.88 2.349z" }), /* @__PURE__ */ e.createElement("path", { d: "M19.142 7.663l-.227.736c-2.331-.736-4.23-1.052-5.69-.954l-.051-.77c1.567-.105 3.555.226 5.968.988zM19.95 11.78l-.431.635c-1.19-.825-2.654-1.24-4.404-1.24v-.77c1.898 0 3.512.456 4.835 1.374z" }), /* @__PURE__ */ e.createElement("path", { d: "M19.302 12.01l.197.745c-2.562.694-4.968 1.088-7.218 1.18-2.265.094-4.905-.302-7.922-1.182l.212-.741c2.943.86 5.504 1.243 7.68 1.153 2.19-.09 4.54-.475 7.051-1.155z" }), /* @__PURE__ */ e.createElement("path", { d: "M19.012 15.636l-1.204 1.234c-2.288-2.286-4.303-3.921-6.032-4.904-1.758-.999-4.051-2.013-6.876-3.04l.58-1.632c2.907 1.056 5.284 2.108 7.135 3.16 1.88 1.068 4.009 2.795 6.397 5.182zM5.46 16.335l-.456-.618a9.275 9.275 0 011.188-.722c.85-.432 1.703-.7 2.516-.726l.12-.001v.77l-.097.002c-.685.021-1.438.259-2.198.644a8.525 8.525 0 00-1.073.65z" }), /* @__PURE__ */ e.createElement("path", { d: "M5.813 16.602l.191-.746c2.54.669 4.499 1.002 5.866 1.002 1.361 0 3.388-.393 6.066-1.182l.213.74c-2.742.808-4.83 1.213-6.28 1.213-1.443 0-3.46-.343-6.056-1.027zM4.824 9.694l1.207-1.232L7.8 10.236l-1.207 1.231-1.768-1.773z" }), /* @__PURE__ */ e.createElement("path", { d: "M14.836 15.847l.898-1.478 2.803 1.745-.897 1.478-2.804-1.745z" })), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.191 12c0 4.311 3.454 7.807 7.715 7.807 4.26 0 7.714-3.496 7.714-7.807 0-4.312-3.454-7.808-7.714-7.808S4.19 7.688 4.19 12zm14.476.096c0 3.726-2.985 6.747-6.666 6.747-3.682 0-6.667-3.021-6.667-6.747 0-3.727 2.985-6.747 6.667-6.747 3.681 0 6.666 3.02 6.666 6.747z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.658 7.185v6.26c.412 2.478 1.8 3.717 4.166 3.717 2.364 0 3.753-1.239 4.165-3.717v-6.26h-8.33z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M7.086 6.606h9.474v6.888l-.008.047c-.458 2.752-2.08 4.2-4.73 4.2-2.648 0-4.27-1.448-4.728-4.2l-.008-.047V6.606z",
      fill: "#C51918"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M9.252 8.71h5.14v4.44s-.382 2.294-2.57 2.294c-2.189 0-2.57-2.293-2.57-2.293V8.71z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 7.084h.723v.482H8v-.482z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.62 7.276h1.332v.241H7.62v-.24z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.62 7.47h.722v.24h-.723v-.24zM8.38 7.47h.724v.24H8.38v-.24zM7.62 8.048H8.1v.723H7.62v-.723zM8.572 8.048h.482v.723h-.482v-.723zM8.191 8.048h.241v.723h-.24v-.723z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.62 7.855h1.332v.241H7.62v-.24zM7.62 8.434h1.332v.24H7.62v-.24z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.81 7.662h.242v.241H7.81v-.24zM8.572 7.662h.241v.241h-.24v-.24zM8.191 7.47h.241v.482h-.24V7.47zM11.62 7.084h.722v.482h-.723v-.482z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.238 7.276h1.334v.241h-1.334v-.24z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.238 7.47h.723v.24h-.723v-.24zM12 7.47h.723v.24H12v-.24zM11.238 8.048h.482v.723h-.482v-.723zM12.191 8.048h.482v.723h-.482v-.723zM11.81 8.048h.242v.723h-.242v-.723z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.238 7.855h1.334v.241h-1.334v-.24zM11.238 8.434h1.334v.24h-1.334v-.24z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.43 7.662h.24v.241h-.24v-.24zM12.191 7.662h.241v.241h-.24v-.24zM11.81 7.47h.242v.482h-.242V7.47zM15.047 7.084h.723v.482h-.723v-.482z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.666 7.276h1.333v.241h-1.333v-.24z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.666 7.47h.723v.24h-.723v-.24zM15.428 7.47h.723v.24h-.723v-.24zM14.666 8.048h.482v.723h-.482v-.723zM15.62 8.048h.481v.723h-.482v-.723zM15.238 8.048h.241v.723h-.24v-.723z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.666 7.855h1.333v.241h-1.333v-.24zM14.666 8.434h1.333v.24h-1.333v-.24z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.857 7.662h.241v.241h-.24v-.24zM15.62 7.662h.24v.241h-.24v-.24zM15.238 7.47h.241v.482h-.24V7.47zM15.047 10.554h.723v.482h-.723v-.482z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.666 10.746h1.333v.241h-1.333v-.24z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.666 10.94h.723v.24h-.723v-.24zM15.428 10.94h.723v.24h-.723v-.24zM14.666 11.518h.482v.723h-.482v-.723zM15.62 11.518h.481v.723h-.482v-.723zM15.238 11.518h.241v.723h-.24v-.723z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.666 11.325h1.333v.241h-1.333v-.24zM14.666 11.903h1.333v.241h-1.333v-.24z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.857 11.132h.241v.24h-.24v-.24zM15.62 11.132h.24v.24h-.24v-.24zM15.238 10.94h.241v.481h-.24v-.481zM8 10.554h.723v.482H8v-.482z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.62 10.746h1.332v.241H7.62v-.24z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.62 10.94h.722v.24h-.723v-.24zM8.38 10.94h.724v.24H8.38v-.24zM7.62 11.518H8.1v.723H7.62v-.723zM8.572 11.518h.482v.723h-.482v-.723zM8.191 11.518h.241v.723h-.24v-.723z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.62 11.325h1.332v.241H7.62v-.24zM7.62 11.903h1.332v.241H7.62v-.24z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.81 11.132h.242v.24H7.81v-.24zM8.572 11.132h.241v.24h-.24v-.24zM8.191 10.94h.241v.481h-.24v-.481zM8.463 14.903l.465-.553.369.31-.465.553-.37-.31z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.367 15.32l.857-1.022.185.155-.857 1.021-.185-.155z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.514 15.443l.464-.553.185.154-.465.554-.184-.155zM9.004 14.86l.465-.554.184.155-.465.553-.184-.155zM8.957 15.815l.31-.37.554.465-.31.37-.554-.466zM9.568 15.085l.31-.37.554.465-.31.37-.554-.465zM9.324 15.377l.155-.185.554.465-.155.185-.554-.465z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.809 15.691l.857-1.021.184.155-.857 1.021-.184-.155zM9.252 16.063l.857-1.022.185.155-.857 1.021-.185-.154z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.785 15.42l.155-.184.185.155-.155.185-.185-.155zM9.273 14.838l.155-.185.185.155-.155.185-.185-.155zM8.88 15.006l.156-.185.369.31-.155.185-.37-.31zM14.979 14.466l.464.554-.369.31-.465-.554.37-.31z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.586 14.298l.857 1.021-.185.155-.857-1.021.185-.155z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.44 14.422l.464.554-.184.154-.465-.553.184-.155zM14.93 15.005l.464.554-.184.155-.465-.554.185-.155zM13.996 14.793l.31.37-.554.464-.31-.37.554-.464zM14.607 15.523l.31.369-.554.464-.31-.369.554-.464zM14.363 15.231l.155.185-.554.465-.155-.185.554-.465z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.145 14.67l.857 1.021-.185.155-.857-1.021.184-.155zM13.701 15.041l.857 1.021-.184.155-.857-1.021.184-.155z",
      fill: "#060101"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.414 14.691l.155.185-.185.155-.155-.185.185-.155zM14.904 15.275l.155.185-.184.155-.155-.185.184-.155zM14.807 14.86l.154.184-.369.31-.155-.185.37-.31z",
      fill: "#F9E813"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.559 9.204h-1.32v.962s.097.496.66.496c.562 0 .66-.496.66-.496v-.962zm-.748.385a.192.192 0 01-.19.193.192.192 0 01-.191-.193c0-.106.085-.193.19-.193s.19.087.19.193zm-.19.964c.104 0 .19-.086.19-.192a.192.192 0 00-.19-.193.192.192 0 00-.191.193c0 .106.085.192.19.192zm.76-.192a.192.192 0 01-.19.192.192.192 0 01-.19-.192c0-.107.085-.193.19-.193s.19.086.19.193zm-.476-.193c.106 0 .19-.086.19-.193a.192.192 0 00-.19-.193.192.192 0 00-.19.193c0 .107.085.193.19.193zm.476-.579a.192.192 0 01-.19.193.192.192 0 01-.191-.193c0-.106.085-.193.19-.193.106 0 .191.087.191.193zM12.559 11.325h-1.32v.962s.097.496.66.496c.562 0 .66-.496.66-.496v-.962zm-.748.385a.192.192 0 01-.19.193.192.192 0 01-.191-.193c0-.106.085-.192.19-.192s.19.086.19.192zm-.19.965c.104 0 .19-.087.19-.193a.192.192 0 00-.19-.193.192.192 0 00-.191.193c0 .106.085.193.19.193zm.76-.193a.192.192 0 01-.19.193.192.192 0 01-.19-.193c0-.107.085-.193.19-.193s.19.086.19.193zm-.476-.193c.106 0 .19-.086.19-.193a.192.192 0 00-.19-.193.192.192 0 00-.19.193c0 .107.085.193.19.193zm.476-.579a.192.192 0 01-.19.193.192.192 0 01-.191-.193c0-.106.085-.192.19-.192.106 0 .191.086.191.192zM14.274 11.325h-1.32v.962s.097.496.66.496c.561 0 .66-.496.66-.496v-.962zm-.748.385a.192.192 0 01-.191.193.192.192 0 01-.19-.193c0-.106.085-.192.19-.192s.19.086.19.192zm-.191.965c.105 0 .19-.087.19-.193a.192.192 0 00-.19-.193.192.192 0 00-.19.193c0 .106.085.193.19.193zm.761-.193a.192.192 0 01-.19.193.192.192 0 01-.191-.193c0-.107.085-.193.19-.193.106 0 .191.086.191.193zm-.476-.193c.105 0 .19-.086.19-.193a.192.192 0 00-.19-.193.192.192 0 00-.19.193c0 .107.085.193.19.193zm.476-.579a.192.192 0 01-.19.193.192.192 0 01-.191-.193c0-.106.085-.192.19-.192.106 0 .19.086.19.192zM10.846 11.325h-1.32v.962s.097.496.66.496c.562 0 .66-.496.66-.496v-.962zm-.748.385a.192.192 0 01-.19.193.192.192 0 01-.191-.193c0-.106.085-.192.19-.192s.19.086.19.192zm-.19.965c.104 0 .19-.087.19-.193a.192.192 0 00-.19-.193.192.192 0 00-.191.193c0 .106.085.193.19.193zm.76-.193a.192.192 0 01-.19.193.192.192 0 01-.19-.193c0-.107.085-.193.19-.193s.19.086.19.193zm-.476-.193c.106 0 .19-.086.19-.193a.192.192 0 00-.19-.193.192.192 0 00-.19.193c0 .107.085.193.19.193zm.476-.579a.192.192 0 01-.19.193.192.192 0 01-.19-.193c0-.106.084-.192.19-.192.105 0 .19.086.19.192zM12.559 13.445h-1.32v.962s.097.496.66.496c.562 0 .66-.496.66-.496v-.962zm-.748.386a.192.192 0 01-.19.192.192.192 0 01-.191-.192c0-.107.085-.193.19-.193s.19.086.19.193zm-.19.964c.104 0 .19-.087.19-.193a.192.192 0 00-.19-.193.192.192 0 00-.191.193c0 .106.085.193.19.193zm.76-.193a.192.192 0 01-.19.193.192.192 0 01-.19-.193c0-.107.085-.193.19-.193s.19.086.19.193zm-.476-.193c.106 0 .19-.086.19-.193a.192.192 0 00-.19-.193.192.192 0 00-.19.193c0 .107.085.193.19.193zm.476-.579a.192.192 0 01-.19.193.192.192 0 01-.191-.192c0-.107.085-.193.19-.193.106 0 .191.086.191.193z",
      fill: "#013399"
    }
  ))
), d = v;
export {
  d as default
};
